//This replicates the logic to parse account data from the Quote Manager

const getDiscountsFromType = (discountType, valueField, allDiscounts) =>
  allDiscounts.reduce((parsedDiscounts, discount) => {
    const discountName = discount[valueField];

    const shouldIncludeDiscount = discount.discountType.toLowerCase() === discountType;

    return shouldIncludeDiscount
      ? {
          ...parsedDiscounts,
          [discountName]: discount.discountAmount,
        }
      : parsedDiscounts;
  }, {});

const mapCustomerSpecificDiscounts = (discountsData) =>
  discountsData
    ? {
        partNumberDiscounts: getDiscountsFromType('part', 'partNumber', discountsData),
        priceLineDiscounts: getDiscountsFromType(
          'pricing line',
          'initialPricingLine',
          discountsData
        ),
      }
    : {};

const mapProductFilters = (filtersData) =>
  filtersData
    ? filtersData.reduce((parsedFilters, filter) => {
        const existingFilterGroup = parsedFilters[filter.type];

        return {
          ...parsedFilters,
          [filter.type]: existingFilterGroup ? existingFilterGroup.concat(filter) : [filter],
        };
      }, {})
    : {};

const mapAccountDetailsToStorage = (data) => {
  const getAccount = data && data.getAccount;

  return getAccount
    ? {
        accountId: getAccount.accountId.substr(0, 15),
        accountName: getAccount.name,
        businessCountry: getAccount.businessCountry,
        accountManagerId: getAccount.accountManager && getAccount.accountManager.id,
        priceType: getAccount.priceType,
        filters: mapProductFilters(getAccount.getProductFilters),
        ...mapCustomerSpecificDiscounts(getAccount.getCustomerSpecificDiscounts),
      }
    : {};
};

export { mapAccountDetailsToStorage };
